import { useTranslation } from 'react-i18next';
import { S } from '../regureStyles';

const SummaryStats = ({ total, totalReady, totalSent, totalErr, loading }) => {
  const { t } = useTranslation();
  const stats = [
    { label: t('screens.bordereaux.statTotalReports'), value: total, color: S.textPrimary },
    { label: t('screens.bordereaux.statReady'), value: totalReady, color: '#15803d' },
    { label: t('screens.bordereaux.statSent'), value: totalSent, color: '#1d4ed8' },
    { label: t('screens.bordereaux.statErrors'), value: totalErr, color: '#991b1b' },
  ];
  return (
    <div style={{ display: 'flex', gap: 0, borderBottom: `1px solid ${S.borderLight}`, background: 'rgba(255,255,255,0.6)', flexShrink: 0 }}>
      {stats.map((s, i) => (
        <div key={s.label} style={{ flex: 1, padding: '12px 20px', borderRight: i < 3 ? `1px solid ${S.borderLight}` : 'none', textAlign: 'center' }}>
          <div style={{ fontSize: 20, fontWeight: 800, color: s.color }}>{loading ? '—' : s.value}</div>
          <div style={{ fontSize: 11, color: S.textMuted, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.8 }}>{s.label}</div>
        </div>
      ))}
    </div>
  );
};

export default SummaryStats;
